import { atom } from 'nanostores';
export const $menuOpen = atom(false);
export const $modalOpen = atom(false);
export const $lastFocusedElement = atom(null);
export function toggleMenu(forceValue) {
  if (typeof forceValue === 'boolean') {
    $menuOpen.set(forceValue);
  } else {
    $menuOpen.set(!$menuOpen.get());
  }
}
export function toggleModal(forceValue) {
  if (typeof forceValue === 'boolean') {
    $modalOpen.set(forceValue);
  } else {
    $modalOpen.set(!$modalOpen.get());
  }
}
export function setLastFocusedElement(value) {
  $lastFocusedElement.set(value);
}

// global side effects
(() => {
  const handleToggledModals = () => {
    const isBodyLocked = $menuOpen.get() || $modalOpen.get();
    if (typeof document === 'undefined' || !document.body) return;
    if (isBodyLocked) {
      document.body.classList.add('is-with-modal');
    } else {
      document.body.classList.remove('is-with-modal');
    }
  };
  $menuOpen.listen(() => {
    handleToggledModals();
  });
  $modalOpen.listen(() => {
    handleToggledModals();
  });
})();